export default "__VITE_ASSET__505288bb__"